export interface TimecardRouteState {
    employeeId: number | null;
    from: string | null;
    to: string | null;
    showTotals: boolean;
    totalsFrom: string | null;
    totalsTo: string | null;
    assignPaycode: boolean;
}

const BASE_PATH = '/timekeeper/timecard';

const isValidDay = (value: string | null): boolean => {
    if (!value) {
        return false;
    }

    return /^\d{4}-\d{2}-\d{2}$/.test(value);
};

const parseBoolean = (value: string | null): boolean => {
    return value === '1' || value === 'true';
};

export const buildTimecardBasePath = (): string => BASE_PATH;

export const buildTimecardPath = (employeeId?: number | string | null): string => {
    if (employeeId === undefined || employeeId === null || employeeId === '') {
        return BASE_PATH;
    }

    return `${BASE_PATH}/${employeeId}`;
};

export const parseTimecardRoute = (pathname: string, search: string): TimecardRouteState => {
    const segments = pathname.split('/').filter(Boolean);

    if (segments[0] !== 'timekeeper' || segments[1] !== 'timecard') {
        return {
            employeeId: null,
            from: null,
            to: null,
            showTotals: false,
            totalsFrom: null,
            totalsTo: null,
            assignPaycode: false,
        };
    }

    const rawId = segments[2];
    const employeeId = rawId && /^\d+$/.test(rawId) ? Number(rawId) : null;

    const params = new URLSearchParams(search);
    const from = params.get('from');
    const to = params.get('to');
    const totalsFrom = params.get('totalsFrom');
    const totalsTo = params.get('totalsTo');

    return {
        employeeId,
        from: isValidDay(from) ? from : null,
        to: isValidDay(to) ? to : null,
        showTotals: parseBoolean(params.get('showTotals')),
        totalsFrom: isValidDay(totalsFrom) ? totalsFrom : null,
        totalsTo: isValidDay(totalsTo) ? totalsTo : null,
        assignPaycode: parseBoolean(params.get('assignPaycode')),
    };
};

export const buildTimecardSearch = (state: {
    from?: string | null;
    to?: string | null;
    showTotals?: boolean;
    totalsFrom?: string | null;
    totalsTo?: string | null;
    assignPaycode?: boolean;
}): string => {
    const params = new URLSearchParams();

    if (state.from && state.to && isValidDay(state.from) && isValidDay(state.to)) {
        params.set('from', state.from);
        params.set('to', state.to);
    }

    if (state.showTotals) {
        params.set('showTotals', '1');

        if (state.totalsFrom && state.totalsTo && isValidDay(state.totalsFrom) && isValidDay(state.totalsTo)) {
            params.set('totalsFrom', state.totalsFrom);
            params.set('totalsTo', state.totalsTo);
        }
    }

    if (state.assignPaycode) {
        params.set('assignPaycode', '1');
    }

    const query = params.toString();
    return query ? `?${query}` : '';
};